import { Navigate, Outlet } from "react-router-dom";
import React from "react";
import { getToken } from "helpers/localStorage";

const PrivateRoutes = () => {
  return getToken() ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
